import baseAPI from '@/api/base';
import { EditZmanim_N, GetZmanim_N, RegisterZmanim_N } from '@/dtos/zmanim_N.dto';
import {
  DELETE_ZMANIM_N_URL,
  EDIT_ZMANIM_N_URL,
  GET_ZMANIM_N_URL,
  REGISTER_ZMANIM_N_URL,
  TOGGLE_ZMANIM_N_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class Zmanim_N {
  static getZmanims_N = async (
    getZmanim_N: GetZmanim_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_ZMANIM_N_URL, {
      params: getZmanim_N,
    });
    return response;
  };

  static registerZmanim_N = async (
    registerZmanim_N: RegisterZmanim_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_ZMANIM_N_URL,
      { ...registerZmanim_N }
    );
    return response;
  };

  static editZmanim_N = async (
    editZmanim_N: EditZmanim_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_ZMANIM_N_URL,
      { ...editZmanim_N }
    );
    return response;
  };

  static toggleZmanim_NIsActive = async (
    payload: Pick<EditZmanim_N, 'id'> | EditZmanim_N
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_ZMANIM_N_IS_ACTIVE_URL,
      {
        ...payload,
      }
    );
    return response;
  };

  static deleteZmanim_N = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_ZMANIM_N_URL}/${id}`
    );
    return response;
  };
}

export default Zmanim_N;
